'use client';

import { useEffect, useState } from 'react';
import { Rnd } from 'react-rnd';

type EnvironmentType = 'production' | 'preproduction' | 'development' | null;

export default function DevBanner() {
    const [environment, setEnvironment] = useState<EnvironmentType>(null);
    const [minimized, setMinimized] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined' && (window.self !== window.top || !!window.opener)) return;
        const env = process.env.NEXT_PUBLIC_ENVIRONMENT as EnvironmentType || 'production';
        setEnvironment(env);
    }, []);

    if (!environment || environment === 'production') return null;

    const isPreprod = environment === 'preproduction';
    const bgGradient = isPreprod
        ? 'linear-gradient(90deg, #3b82f6, #6366f1, #a855f7)'
        : 'linear-gradient(90deg, #eab308, #f97316, #ef4444)';
    const title = isPreprod ? '🔵 PRE-PROD' : '⚠️ DEV';
    const subtitle = isPreprod
        ? 'Testing Environment • Isolated Data'
        : 'Test Mode • Stripe Test Keys Active';

    return (
        <Rnd
            default={{ x: 16, y: 16, width: 'auto' as never, height: 'auto' as never }}
            enableResizing={false}
            bounds="window"
            style={{ zIndex: 9999, position: 'fixed' }}
            cancel=".no-drag"
        >
            <div
                style={{ background: bgGradient, cursor: 'grab' }}
                className="rounded-xl shadow-2xl text-white text-xs font-bold select-none overflow-hidden"
            >
                <div className="flex items-center gap-2 px-3 py-2">
                    <span className="uppercase tracking-wider whitespace-nowrap">{title}</span>
                    {!minimized && (
                        <span className="no-drag hidden md:inline opacity-80 font-normal whitespace-nowrap">
                            {subtitle}
                        </span>
                    )}
                    <button
                        className="no-drag ml-1 opacity-60 hover:opacity-100 transition-opacity leading-none"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setMinimized(p => !p)}
                        title={minimized ? 'Expand' : 'Minimize'}
                    >
                        {minimized ? '＋' : '−'}
                    </button>
                </div>
            </div>
        </Rnd>
    );
}
